import { render } from "./list-client.vue?vue&type=template&id=40177e80"
import script from "./list-client.vue?vue&type=script&lang=js"
export * from "./list-client.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__